module.exports = __webpack_public_path__ + "img/Woodpecker.77de60dd.svg";